import React from 'react'
import { FaArrowAltCircleRight } from "react-icons/fa";
import './learnmore.css';

interface Props {
    to       : string;
    children : string;
}

export class LearnMore extends React.Component<Props> {

    render() {
        return (
            <div className="learn-more-container">
                <a className="learn-more" href= { this.props.to }>
                    <span className="learn-more-desc" suppressHydrationWarning={true}>{ this.props.children }</span>
                    <span className="learn-more-icon">
                        { React.createElement(FaArrowAltCircleRight as React.ComponentType) }
                    </span>
                </a>
            </div>
        );
    }
}

